import axios, { AxiosError } from "axios";

interface UnauthenticatedResponse {
  location: string;
}

export const httpClient = axios.create({
  withCredentials: true,
  baseURL: "/api",
  headers: {
    "x-is-xhr": true,
  },
});

interface HttpClientConfig {
  marketHeader: string | undefined;
}

export const httpClientConfig: HttpClientConfig = {
  marketHeader: undefined,
};

httpClient.interceptors.request.use(config => {
  if (config.headers) {
    config.headers["Request-Id"] = Math.random().toString(36).slice(2);
    if (httpClientConfig.marketHeader) {
      config.headers["Market"] = httpClientConfig.marketHeader;
    }
  }
  return config;
});

httpClient.interceptors.response.use(
  response => {
    return response;
  },
  (error: AxiosError<UnauthenticatedResponse>) => {
    if (shouldRedirect(error)) {
      window.location.href = (
        error.response?.data as UnauthenticatedResponse
      ).location;
    } else {
      return Promise.reject(error);
    }
  }
);

const shouldRedirect = (error: AxiosError) => {
  if (
    error.response?.status === 401 &&
    (error.response.data as UnauthenticatedResponse).location
  ) {
    return true;
  }

  return false;
};
